module.exports = __webpack_public_path__ + "img/green_030.8969e6fb.png";